class MFRTestimonialCarousel {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
          nav: ".testimonial-carousel__icon li a",
          text: ".testimonial-carousel__text",
          heading: ".testimonial-carousel__text blockquote",
          activeNav: ".testimonial-carousel__text [aria-hidden='false']",
          iconsCarousel: ".testimonial-carousel__icon"
        };

        this.init();
    }

    init() {
      this.$nav = this.$element.find(this.selectors.nav);
      this.$text = this.$element.find(this.selectors.text);
      this.$heading = this.$element.find(this.selectors.heading);

      this.setHeight();
      window.onWidthResize(() => {
        this.setHeight();
      });

      this.$nav
        .on(
          "mfr:testimonial-carousel-change click",
          this.__handleNavClick.bind(this)
        );
    }

    setHeight() {
        var maxHeight = Math.max.apply(
          null,
          this.$heading
            .map(function () {
              return $(this).height();
            })
            .get()
        );
        this.$text.height(maxHeight);
    }

    __handleNavClick(e) {
        const index = $( e.currentTarget ).data( "index" );
        const carousel = $( e.currentTarget ).closest( this.selectors.iconsCarousel );

        this.setActive( index );

        if( carousel.hasClass( "flickity-enabled" ) ) {
          carousel.flickity( "selectCell", index );
        }
        
    }

    setActive( index ) {
        this.setActiveImage(index);
        this.setActiveNav(index);
    }

    setActiveImage( index ) {
        this.$heading.each((i, e) => {
          $(e).attr("aria-hidden", "true");
        });
        this.$element.find( `${ this.selectors.heading }[data-index="${index}"]`).attr(
          "aria-hidden",
          "false"
        );
        // this.$text.height(
        //   this.$element
        //     .find(`${this.selectors.heading}[data-index="${index}"]`)
        //     .height()
        // );
    }

    setActiveNav(index) {
        this.$nav.removeClass( "is-active" );
        this.$element.find( `${ this.selectors.nav }[data-index="${index}"]` ).addClass( "is-active" );
    }
}